const logger = {
  success: (text: string, color = '#26a65b'): void =>
    console.log(`%c${text}`, `color: ${color}`),
  error: (text: string, color = '#cf000f'): void =>
    console.log(`%c${text}`, `color: ${color}`),
  warn: (text: string, color = '#d35400'): void =>
    console.log(`%c${text}`, `color: ${color}`),
};

export default logger;
